// extracted by mini-css-extract-plugin
export var content = "testimonial-module--content--jXFui";
export var testimonial = "testimonial-module--testimonial--BZ4K4";
export var quote = "testimonial-module--quote--ZLqRT";
export var author = "testimonial-module--author--4DshP";
export var avatar = "testimonial-module--avatar--90usX";
export var authorInfo = "testimonial-module--authorInfo--lGU0S";